<template lang='pug'>
.mainWrapper-innerContent
  .mainWrapper-leftContent.mainWrapper-leftContent--fullWidth
    BreadCrumb(:breadcrumbList="breadcrumbs" normal)
    PartnerGridBlock(type='partners' :data="data.partnerGrid")
</template>
<script>
import BreadCrumb from '@/components/modules/breadcrumb/breadcrumb.vue'
import PartnerGridBlock from '@/components/partner_grid/partner_grid_block.vue'

export default {
  props: {
    data: Object,
    breadcrumbList: Array
  },
  components: {
    BreadCrumb,
    PartnerGridBlock
  },
  data() {
    return {
      breadcrumbs: JSON.parse(JSON.stringify(this.breadcrumbList))
    }
  },
  created() {
    this.breadcrumbs.push({
      text: '合作夥伴',
      link: '/partners'
    })
  }
}
</script>
